import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import {
  ActivitySectionDirective,
  CallWaiterService,
  RestaurantTableService,
  UserActivityClickTrackingDirective,
} from '@core';
import { ServiceCenterSectionsComponent } from '@app/components/service-center-sections/service-center-sections.component';
import { CallWaiterMainButtonComponent } from '@app/components/call-waiter-main-button/call-waiter-main-button.component';
import { LanguageSwitcherComponent } from '@app/components/language-switcher/language-switcher.component';
import { ServiceCenterAmenitiesComponent } from '@app/components/service-center-amenities/service-center-amenities.component';

@Component({
  selector: 'app-service-centre',
  templateUrl: './service-centre.component.html',
  imports: [
    TranslateModule,
    ServiceCenterSectionsComponent,
    UserActivityClickTrackingDirective,
    ActivitySectionDirective,
    CallWaiterMainButtonComponent,
    LanguageSwitcherComponent,
    ServiceCenterAmenitiesComponent,
  ],
  styleUrls: ['./service-centre.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCentreComponent {

  public readonly table = toSignal(this.restaurantTable.table$);

  public readonly withCallWaiterMain = toSignal(this.callWaiterService.withMain$, {
    initialValue: false,
  });

  public readonly callWaiterMain = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  constructor(
    private readonly restaurantTable: RestaurantTableService,
    private readonly callWaiterService: CallWaiterService,
  ) {}

}
